


















































































































































































































































































































import Vue from "vue";
import NavListItem from "@/components/app/NavListItem.vue";
import LoginDialog from "@/components/app/LoginDialog.vue";
import ErrorDialog from "@/components/app/ErrorDialog.vue";
import User from "@/User";
import { LoggedInDiscordUser } from "./types";

export default Vue.extend({
  name: "App",
  metaInfo: {
    title: "Newfound Pioneer Corps",
    meta: [
      { vmid: "description", name: "description", content: "The Newfound Pioneer Corps is an Arma 3 unit focussing on playing lots of different settings in regular events. Become an NPC today!" },
      { vmid: "og:site_name", property: "og:site_name", content: "Newfound Pioneer Corps" },
      { vmid: "og:type", property: "og:type", content: "website" },
      { vmid: "og:image", property: "og:image", content: "https://arma.npcs.games/logo.png" },
    ],
  },
  components: {
    NavListItem,
    LoginDialog,
    ErrorDialog,
  },
  data: () => ({
    drawer: false,
    group: null,
    userDataKey: 0, // Used to force reactivity when user data changes
    isModerator: false, // Store moderator status as data property
    burgerMenu: false,
  }),
  computed: {
    isLoggedIn(): boolean {
      return this.$store.getters.isLoggedIn;
    },
    avatarUri(): string {
      const user = User.get();
      if (user !== null) {
        return `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}?size=32`;
      }
      return "";
    },
    navRankIconUrl(): string {
      // tslint:disable-next-line:no-unused-expression
      this.userDataKey;
      // tslint:disable-next-line:no-unused-expression
      this.$store.getters.userDataVersion;
      const user = User.get();
      if (!user || !user.selectedIcon) { return ""; }
      try {
        return require(`@/assets/images/icons/${user.selectedIcon.filename}.svg`);
      } catch {
        return "";
      }
    },
    user(): LoggedInDiscordUser | null {
      // Force reactivity by accessing userDataKey and store version
      // tslint:disable-next-line:no-unused-expression
      this.userDataKey;
      // tslint:disable-next-line:no-unused-expression
      this.$store.getters.userDataVersion;
      return User.get();
    },
    dataSnackbar: {
      get: () => {
        const snackbar = localStorage.getItem("data-snackbar");
        if (snackbar === null) {
          return true;
        }

        return false;
      },
      set: (newValue: any) => {
        localStorage.setItem("data-snackbar", newValue.toString());
      },
    },
    errorSnackbar: {
      get(): boolean {
        return this.$store.getters.errorSnackbar;
      },
      set(value: boolean) {
        if (!value) {
          this.$store.commit("clearErrorSnackbar");
        }
      },
    },
    errorSnackbarMessage(): string {
      return this.$store.getters.errorSnackbarMessage;
    },
  },
  watch: {
    // Refresh user data whenever route changes
    $route() {
      this.burgerMenu = false;
      this.refreshUserData();
    },
    // Update moderator status when user changes
    user(newUser) {
      if (newUser === null) {
        this.isModerator = false;
      } else {
        this.checkModeratorStatus();
      }
    },
  },
  mounted() {
    // Initial refresh if user is logged in
    if (this.user !== null) {
      this.refreshUserData();
      this.checkModeratorStatus();
    }
  },
  methods: {
    async checkModeratorStatus() {
      this.isModerator = await User.isModerator();
    },

    async refreshUserData() {
      const user = User.get();
      if (user !== null) {
        try {
          await User.refreshUserData();
          // Trigger reactivity update
          this.userDataKey++;
          // Update moderator status after refreshing user data
          await this.checkModeratorStatus();
        } catch (error) {
          // Silently fail - user will still see their cached data
        }
      }
    },

    login() {
      User.login();
    },

    logout() {
      User.logout();
    },

    dismissErrorSnackbar() {
      this.$store.commit("clearErrorSnackbar");
    },
  },
});
